import {apiTickersRequests} from '#/repository/api-tickers-requests';
import {useQuery} from '@tanstack/react-query';
import {GraphRange} from 'shareland-common';

export const useLandTicker = (graphRange: GraphRange, tokenSymbol: string) =>
  useQuery({
    queryKey: ['land-ticker', graphRange, tokenSymbol],
    queryFn: () => apiTickersRequests.getLandTicker({graphRange, tokenSymbol}),
    refetchOnMount: true,
  });
